import React, { useState, useEffect } from 'react';
// Importamos el nuevo service de reseñas
import { obtenerTodasLasReseñas, eliminarReseña, cambiarVisibilidadReseña } from '../../services/ResenasService';

// Estilos
import '../static/Global.css';
import '../static/Home.css';
import '../static/Aside.css';
import '../static/Flotante.css';

function DashboardResenas() {
    const [reseñas, setReseñas] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cargarLista();
    }, []);

    const cargarLista = async () => {
        try {
            const data = await obtenerTodasLasReseñas();
            setReseñas(data);
            setLoading(false);
        } catch (error) {
            alert("Error al cargar reseñas: " + error.message);
        }
    };

    // Función para activar/desactivar visibilidad
    const handleToggleVisibilidad = async (id, estadoActual) => {
        try {
            const nuevoEstado = !estadoActual;
            await cambiarVisibilidadReseña(id, nuevoEstado);
            // Actualizamos el estado local para que el cambio sea instantáneo en la UI
            setReseñas(reseñas.map(r => r.id === id ? { ...r, visibilidad: nuevoEstado } : r));
        } catch (error) {
            alert("Error al cambiar visibilidad");
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("¿Estás seguro de eliminar esta reseña permanentemente?")) {
            try {
                await eliminarReseña(id);
                setReseñas(reseñas.filter(r => r.id !== id));
                alert("Reseña eliminada correctamente.");
            } catch (error) {
                alert("Error al eliminar");
            }
        }
    };

    return (
        <section className="main__content">
            <div className="table-container">
                <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h2>LISTADO DE RESEÑAS</h2>
                </div>

                <div className="table-responsive">
                    <table className="novatech-table">
                        <thead>
                            <tr>
                                <th>Usuario</th>
                                <th>Comentario</th>
                                <th>Puntuación</th>
                                <th>Visibilidad</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="5">cargando reseñas...</td></tr>
                            ) : reseñas.length === 0 ? (
                                <tr><td colSpan="5">No hay reseñas para mostrar.</td></tr>
                            ) : (
                                reseñas.map((r) => (
                                    <tr key={r.id}>
                                        <td data-label="Usuario">
                                            <div style={{ fontWeight: 'bold' }}>{r.nombre}</div>
                                            <div style={{ fontSize: '0.8rem', color: '#666' }}>{r.correo}</div>
                                        </td>
                                        <td data-label="Comentario">
                                            <div style={{ maxWidth: '300px', fontSize: '0.9rem' }}>
                                                "{r.comentario}"
                                            </div>
                                        </td>
                                        <td data-label="Puntuación" style={{ color: '#ffc107' }}>
                                            {"★".repeat(r.puntuacion)}
                                        </td>
                                        <td data-label="Visibilidad">
                                            <button 
                                                onClick={() => handleToggleVisibilidad(r.id, r.visibilidad)}
                                                className={r.visibilidad ? "btn-status-active" : "btn-status-inactive"}
                                                style={{
                                                    padding: '5px 10px',
                                                    borderRadius: '20px',
                                                    border: 'none',
                                                    backgroundColor: r.visibilidad ? '#28a745' : '#dc3545',
                                                    color: 'white',
                                                    cursor: 'pointer',
                                                    fontSize: '0.75rem'
                                                }}
                                            >
                                                {r.visibilidad ? 'VISIBLE' : 'OCULTO'}
                                            </button>
                                        </td>
                                        <td data-label="Acciones" className="actions-cell">
                                            <button className="btn-delete" onClick={() => handleDelete(r.id)}>
                                                <i className="fa fa-trash"></i> Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    );
}

export default DashboardResenas;